import { render, staticRenderFns } from "./PosCustomer.vue?vue&type=template&id=3a378c25&"
import script from "./PosCustomer.vue?vue&type=script&lang=js&"
export * from "./PosCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports